var _path, _g, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5.012h17.052v19.853H.5V.012Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.073 1.512a3.087 3.087 0 0 0-3.072 2.997v10.719a3.064 3.064 0 0 0 2.99 3.138h8.082a3.097 3.097 0 0 0 2.98-3.133V6.34l-4.635-4.828H5.073Zm.012 18.354H4.96a4.562 4.562 0 0 1-4.458-4.654V4.49C.561 2.01 2.608.01 5.071.01H11.737c.203 0 .398.084.54.23l5.066 5.278a.753.753 0 0 1 .208.519v9.19a4.594 4.594 0 0 1-4.453 4.638H5.085Z",
    fill: "#32324B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.798 6.984h-2.754a3.331 3.331 0 0 1-3.318-3.325V.75a.75.75 0 0 1 1.5 0v2.909c0 1.004.816 1.822 1.82 1.825h2.752a.75.75 0 0 1 0 1.5ZM8.642 14.7a.75.75 0 0 1-.75-.75V7.91a.75.75 0 0 1 1.5 0v6.04a.75.75 0 0 1-.75.75Z",
    fill: "#32324B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.297 11.014a.749.749 0 0 1-.531-1.279L8.11 7.38a.772.772 0 0 1 1.063 0l2.346 2.356a.75.75 0 1 1-1.063 1.058L8.642 8.971l-1.814 1.822a.743.743 0 0 1-.53.221Z",
    fill: "#32324B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperUpload);
export default __webpack_public_path__ + "static/media/paper_upload.ba34bffef206dbc61144e16ac433af91.svg";
export { ForwardRef as ReactComponent };